// extracted by mini-css-extract-plugin
export default {"title":"atRl6","allPackagesBtn":"qpz9K"};